import {makeStyles} from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  logo: {
    width: 200,
    display: 'inline-block',
    '& a': {
      display: 'block',
      flex: '0 0 100px'
    },
    [theme.breakpoints.down('sm')]: {
      width: 200,
      margin: 'auto',
      padding: theme.spacing(1, 0)
    }
  }
}))
